<template>
    <div class="text-center pt-5">
        <h3>
          404 - Sidan hittades inte
        </h3>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
};
</script>
